import { LocalDateTime, ZoneOffset } from 'js-joda';
import { SharedAppConstants } from '@tock/shared-app-constants';

interface State {
  lastVersionSeen: number;
  lastEventsUpgradeNagSeenEpochSec: number;
}

const initialState: State = {
  lastVersionSeen: 0,
  lastEventsUpgradeNagSeenEpochSec: 0,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case SharedAppConstants.ANNOUNCEMENTS_SET_UPDATE_SEEN:
      return {
        ...state,
        lastVersionSeen: payload,
      };
    case SharedAppConstants.ANNOUNCEMENTS_SHOW_EVENTS_UPGRADE_NAG:
      return {
        ...state,
        lastEventsUpgradeNagSeenEpochSec: LocalDateTime.now().toEpochSecond(ZoneOffset.UTC),
      };
    default:
      return state;
  }
}
